import AccountProfile from './account-profile.svg';
import DataExport from './data-export.svg';
import Integrations from './integrations.svg';
import Labs from './labs.svg';
import Privacy from './privacy.svg';
import Recording from './recording.svg';
import Setup from './setup.svg';
import Subscription from './subscription.svg';
import Webhooks from './webhooks.svg';

export default {
  'settings/account-profile': AccountProfile,
  'settings/data-export': DataExport,
  'settings/integrations': Integrations,
  'settings/labs': Labs,
  'settings/privacy': Privacy,
  'settings/recording': Recording,
  'settings/setup': Setup,
  'settings/subscription': Subscription,
  'settings/webhooks': Webhooks,
};
